"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationsClientRaw = exports.TranslationsClient = void 0;
class TranslationsClient {
    constructor(adapter) {
        this.adapter = adapter;
        this.raw = new TranslationsClientRaw(this.adapter);
    }
    getDefaults(name, lang, options) {
        return this.adapter.request('get', `/${name}/translations/lang/${lang}/defaults`, null, null, options).then(toData);
    }
}
exports.TranslationsClient = TranslationsClient;
class TranslationsClientRaw {
    constructor(adapter) {
        this.adapter = adapter;
    }
    getDefaults(name, lang, options) {
        return this.adapter.request('get', `/${name}/translations/lang/${lang}/defaults`, null, null, options);
    }
}
exports.TranslationsClientRaw = TranslationsClientRaw;
// helpers
function toData(res) {
    return res.data;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhbnNsYXRpb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FwaXMvdHJhbnNsYXRpb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLE1BQWEsa0JBQWtCO0lBRzlCLFlBQW1CLE9BQXVCO1FBQXZCLFlBQU8sR0FBUCxPQUFPLENBQWdCO1FBQ3pDLElBQUksQ0FBQyxHQUFHLEdBQUcsSUFBSSxxQkFBcUIsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUE7SUFDbkQsQ0FBQztJQUVELFdBQVcsQ0FBQyxJQUF1QixFQUFFLElBQXdCLEVBQUUsT0FBVztRQUN6RSxPQUFPLElBQUksQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDLEtBQUssRUFBRSxJQUFJLElBQUksc0JBQXNCLElBQUksV0FBVyxFQUFFLElBQUksRUFBRSxJQUFJLEVBQUUsT0FBTyxDQUFDLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFBO0lBQ3BILENBQUM7Q0FDRDtBQVZELGdEQVVDO0FBRUQsTUFBYSxxQkFBcUI7SUFDakMsWUFBbUIsT0FBdUI7UUFBdkIsWUFBTyxHQUFQLE9BQU8sQ0FBZ0I7SUFBRyxDQUFDO0lBRTlDLFdBQVcsQ0FBQyxJQUF1QixFQUFFLElBQXdCLEVBQUUsT0FBVztRQUN6RSxPQUFPLElBQUksQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDLEtBQUssRUFBRSxJQUFJLElBQUksc0JBQXNCLElBQUksV0FBVyxFQUFFLElBQUksRUFBRSxJQUFJLEVBQUUsT0FBTyxDQUFDLENBQUE7SUFDdkcsQ0FBQztDQUNEO0FBTkQsc0RBTUM7QUFFRCxVQUFVO0FBRVYsU0FBUyxNQUFNLENBQUMsR0FBRztJQUNsQixPQUFPLEdBQUcsQ0FBQyxJQUFJLENBQUE7QUFDaEIsQ0FBQyJ9